/** Preserve login MFA anchor: factor select/resend must not change the 5-minute client window. */
export function resolveLoginMfaExpiry(
  baseExpiresAt?: number,
  updateExpiresAt?: number,
  loginAnchorExpiresAt?: number,
): number | undefined {
  if (loginAnchorExpiresAt != null) {
    return loginAnchorExpiresAt;
  }

  if (baseExpiresAt != null && updateExpiresAt != null) {
    return Math.min(updateExpiresAt, baseExpiresAt);
  }

  return updateExpiresAt ?? baseExpiresAt;
}

export function pickLoginMfaExpiryBase(
  contextExpiresAt?: number,
  storeExpiresAt?: number,
  loginAnchorExpiresAt?: number,
): number | undefined {
  return contextExpiresAt ?? storeExpiresAt ?? loginAnchorExpiresAt;
}
